<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span class="dialog-title">{{title}}</span>
    </h1>
    <div class="centerwrap scroll content" fxFlex.gt-sm="auto">
        <div class="dialog-message" [innerHTML]="message | safeHTML"></div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="margin-top margin-bottom">
            <div>Application theme:</div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>light_mode</mat-icon>
                    <span>Light</span>
                </div>
                <mat-slide-toggle [checked]="CurrentTheme === 'my-dark-theme'" (change)="ToggleTheme($event)"></mat-slide-toggle>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <span>Dark</span>
                    <mat-icon>dark_mode</mat-icon>
                </div>
            </div>
        </div>
    </div>
    <div
        class="button-bar"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center center"
        fxLayoutGap.lt-md="10px"
    >
        <button mat-raised-button color="primary" class="okbtn" (click)="OKHandler()">{{oktext}}</button>
    </div>
</div>
